import { useAccount } from "wagmi";
import { IconButton, Menu, MenuButton, MenuItem, MenuList, useBreakpointValue } from "@chakra-ui/react";
import { FilterIcon } from "@looksrare/uikit";
import { useTranslation } from "next-i18next";
import { Button } from "uikit";
import { Radio } from "uikit/Radio";
import { FilterOption } from "views/win/userGeneratedRaffles/components/RafflesGrid/utils";

interface FilterButtonProps {
  options: FilterOption[];
  selectedOption: FilterOption;
  onSelect: (option: FilterOption) => void;
}

/**
 * This acts as a radio toggle.
 */
export const FilterButton = ({ selectedOption, options, onSelect }: FilterButtonProps) => {
  const isMdOrGreater = useBreakpointValue({ base: false, md: true });
  const { address } = useAccount();
  const { t } = useTranslation();
  return (
    <Menu>
      {isMdOrGreater ? (
        <MenuButton as={Button} leftIcon={<FilterIcon />} variant="outline" colorScheme="secondary">
          {t("Filter")}
        </MenuButton>
      ) : (
        <MenuButton
          as={IconButton}
          icon={<FilterIcon />}
          aria-label="raffles-filter"
          variant="outline"
          colorScheme="secondary"
        />
      )}
      <MenuList zIndex="dropdown">
        {options.map((option) => {
          const handleSelect = () => onSelect(option);
          return (
            <MenuItem
              key={option.label}
              icon={<Radio isChecked={option.label === selectedOption.label} />}
              onClick={handleSelect}
              data-id={`raffle_filter-${option.label}`}
              isDisabled={!address && option.label !== "All Raffles"}
            >
              {option.label}
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};
